export default "__VITE_ASSET__DXdL1It1__"